class AssertError extends Error {}

export function assert(condition: unknown, message: string): asserts condition {
    if (!condition) {
        throw new AssertError(message);
    }
}

/**
 * @param min >= min (包含)
 * @param max < max (不包含)
 */
export function random(min: number, max: number) {
    return min + Math.floor(Math.random() * (max - min));
}

export function randomPicks<T>(candidates: T[], count = 1): T[] {
    if (count === 1) {
        return [candidates[random(0, candidates.length)]];
    } else {
        const i = random(0, candidates.length);
        return [candidates[i]].concat(randomPicks(candidates, count-1));
    }
}

export function amend <item> (items: item[], index: number, newItem: item): item[] {
    return items.slice(0, index).concat([newItem]).concat(items.slice(index + 1));
}
